export const FIELDGLASS_ISSUE_TYPE_VALUES = [
  'job_posting_error',
  'shift_mapping_error',
  'worker_profile_incomplete',
  'attachment_upload_error',
  'job_seeker_submission_error',
  'job_seeker_removal_error',
  'timesheet_mismatch',
  'timesheet_not_found',
  'attestation_submission_error',
] as const

export type FieldglassOperationIssueType =
  (typeof FIELDGLASS_ISSUE_TYPE_VALUES)[number]

export const FIELDGLASS_ISSUE_TYPE_LABELS: Record<
  FieldglassOperationIssueType,
  string
> = {
  job_posting_error: 'Job posting error',
  shift_mapping_error: 'Shift mapping error',
  worker_profile_incomplete: 'Worker profile incomplete',
  attachment_upload_error: 'Document not attached',
  job_seeker_submission_error: 'Job seeker rejected by Fieldglass',
  job_seeker_removal_error: 'Job seeker could not be removed',
  timesheet_mismatch: 'Timesheet mismatch',
  timesheet_not_found: 'No Fieldglass timesheet found',
  attestation_submission_error: 'Attestation submission failed',
}

export const FIELDGLASS_ISSUE_TYPE_OPTIONS: {
  value: FieldglassOperationIssueType
  label: string
}[] = FIELDGLASS_ISSUE_TYPE_VALUES.map((value) => ({
  value,
  label: FIELDGLASS_ISSUE_TYPE_LABELS[value],
}))

export const AUTOMATIC_RESOLUTION_ISSUE_TYPES: FieldglassOperationIssueType[] =
  ['shift_mapping_error']
